import { Map } from 'immutable'

/**
 * `{ shareId, kind }` for the public AI share page, seeded by the server hydrate
 * and never changed on the client. It lets the header and the page choose the
 * Dreams or the chat shell before any client query answers, so the server render
 * and hydration agree.
 */
export const initialState = Map()

export default function aiShareReducer (state = initialState) {
  return state
}
